// extracted by mini-css-extract-plugin
export default {"fade":"IconContent_fade__nUkQk","modal-backdrop":"IconContent_modal-backdrop__qD8d9","show":"IconContent_show__bj4Hn","InverseColors":"IconContent_InverseColors__OAt+R"};